module.exports = __webpack_public_path__ + "img/Arabic-05.e939efde.jpg";